export const ExternalDealPartial = `
... on ExternalDeal {
	contact {
        thirdPartyUser {
            id
            accountId
            externalId
            name
            nickname
            email
			picture
            extendedProfile {
                jobTitle
                department
                organization
            }
        }
        user {
            id
            name
        }
	}
	stage
	accountName
	lastActivity {
		lastActivityAt
		event
	}
	dealClosedAt
	opportunityAmount {
		value
		currencyCode
	}
	isClosed
	contributors {
		user {
			thirdPartyUser {
				id
				name
			}
		}
	}
}
`;
